import './index.scss'

import { Controller as BaseController } from 'stimulus'
import { useMutation, useDebounce } from 'stimulus-use'

export class Controller extends BaseController {
  static targets = ['labelsContainer', 'issuesContainer', 'topicsContainer']
  static debounces = ['showLabelsValueChanged', 'showIssuesValueChanged', 'showTopicsValueChanged']
  static values = {
    showLabels: Boolean,
    showIssues: Boolean,
    showTopics: Boolean
  }

  connect() {
    useDebounce(this)
    useMutation(this, { childList: true, subtree: true })
  }

  mutate(entries) {
    for (const mutation of entries) {
      if (mutation.type === 'childList') {
        this.showLabelsValueChanged()
        this.showIssuesValueChanged()
        this.showTopicsValueChanged()
      }
    }
  }

  showLabelsValueChanged() {
    if (this.hasLabelsContainerTarget) {
      this._toggle(this.labelsContainerTarget, this.showLabelsValue)
    }
  }

  showIssuesValueChanged() {
    if (this.hasIssuesContainerTarget) {
      this._toggle(this.issuesContainerTarget, this.showIssuesValue)
    }
  }

  showTopicsValueChanged() {
    if (this.hasTopicsContainerTarget) {
      this._toggle(this.topicsContainerTarget, this.showTopicsValue)
    }
  }

  hideLabels() { this.showLabelsValue = false }
  showLabels() { this.showLabelsValue = true }
  hideIssues() { this.showIssuesValue = false }
  showIssues() { this.showIssuesValue = true }
  hideTopics() { this.showTopicsValue = false }
  showTopics() { this.showTopicsValue = true }

  _toggle(elem, show) {
    if (!elem) { return }

    if (show) {
      elem.classList.remove('hidden')
    } else {
      elem.classList.add('hidden')
    }
  }
}
